import { browser } from '$app/environment';

// 회원가입 진입 경로 태깅 (한컴 앱은 ?signupSource=HANCOM_APP 로 진입, 미지정 시 WEB)
const STORAGE_KEY = 'signup-source';
const SIGNUP_SOURCES = ['WEB', 'HANCOM_APP'] as const;

export type SignupSource = (typeof SIGNUP_SOURCES)[number];

export const DEFAULT_SIGNUP_SOURCE: SignupSource = 'WEB';

const isSignupSource = (value: string | null): value is SignupSource => !!value && (SIGNUP_SOURCES as readonly string[]).includes(value);

// 진입 URL의 signupSource 쿼리 파라미터를 sessionStorage에 보관해 멀티스텝 가입 플로우 동안 값을 유지한다.
export const captureSignupSource = (url: URL) => {
    if (!browser) return;

    const source = url.searchParams.get('signupSource');
    if (isSignupSource(source)) {
        sessionStorage.setItem(STORAGE_KEY, source);
    }
};

export const getSignupSource = (): SignupSource => {
    if (!browser) return DEFAULT_SIGNUP_SOURCE;

    const stored = sessionStorage.getItem(STORAGE_KEY);
    return isSignupSource(stored) ? stored : DEFAULT_SIGNUP_SOURCE;
};

export const clearSignupSource = () => {
    if (!browser) return;

    sessionStorage.removeItem(STORAGE_KEY);
};
